import APIRequest from '../api/APIRequest';

export const homeworkService = {
  // Get all homeworks
  getAllHomeworks: async (token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/admin/getAllHomeworks', 'GET', {}, token);
      if (response.success) {
        return response.homeworks;
      } else {
        return [];
      }
    } catch (error) {
      console.error('Error fetching homeworks:', error);
      return [];
    }
  },

  // Get homework by ID
  getHomeworkById: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/getHomework?id=${id}`, 'GET', {}, token);
      if (response.success) {
        return response.homework;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching homework:', error);
      return null;
    }
  },

  // Create new homework
  createHomework: async (homeworkData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request('/admin/createHomework', 'POST', homeworkData, token);
      return response;
    } catch (error) {
      console.error('Error creating homework:', error);
      return { success: false, message: 'Failed to create homework' };
    }
  },

  // Update homework
  updateHomework: async (id, homeworkData, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/updateHomework?id=${id}`, 'POST', homeworkData, token);
      return response;
    } catch (error) {
      console.error('Error updating homework:', error);
      return { success: false, message: 'Failed to update homework' };
    }
  },

  // Delete homework
  deleteHomework: async (id, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/deleteHomework?id=${id}`, 'DELETE', {}, token);
      return response;
    } catch (error) {
      console.error('Error deleting homework:', error);
      return { success: false, message: 'Failed to delete homework' };
    }
  },

  // Update student status
  updateHomeworkStatus: async (id, studentId, status, token) => {
    try {
      const api = new APIRequest();
      const response = await api.request(`/admin/updateHomeworkStatus?id=${id}`, 'POST', { studentId, status }, token);
      return response;
    } catch (error) {
      console.error('Error updating homework status:', error);
      return { success: false, message: 'Failed to update status' };
    }
  },
};
